export default "__VITE_ASSET__pROUlqPH__"